<template>
  <v-container>
    <v-row>
      <v-col
        xs="12"
      >
        <v-card>
          <v-btn @click="dialog = true" fab fixed bottom right dark color="indigo">
            <v-icon dark>add</v-icon>
          </v-btn>
          <v-card-text>
            <List @edit="edit"/>
          </v-card-text>      
        </v-card>
      </v-col>
    </v-row>
    <Create 
      @closeDialog="closeDialog"
      :dialog="dialog"
      :selected="selected"
    />
  </v-container>
</template>

<script>
  import Create from './Create.vue'
  import List from './List.vue'

export default {
  components: {
    Create,
    List,    
  },
  name: 'LeadSegmentations',

  data () {
    return {
      dialog: false,
      selected: null
    }
  },
  methods: {
    edit (data) {
      this.selected = data;
      this.dialog = true;
    },
    closeDialog() {
      this.selected = null;
      this.dialog = false;
    }
  }
}
</script>

<style lang="css" scoped>
</style>